import * as Sentry from '@sentry/react';

const IGNORED_MESSAGES = new Set(['Not authenticated']);

export function reportError(error: unknown, extra?: Record<string, unknown>) {
  if (error instanceof Error && IGNORED_MESSAGES.has(error.message)) {
    return;
  }
  Sentry.captureException(error, extra ? { extra } : undefined);
}
